import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from '@trg/utils';

export interface InfoAlertOptions {
  message?: string;
  confirmText?: string;
  cancelText?: string;
  closable?: boolean;
  autoFocus?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export interface InfoModalState {
  isInfoAlertOpen: boolean;
  infoAlertOptions: InfoAlertOptions | null;
}

export interface InfoModalAction {
  openInfoAlert: (options: InfoAlertOptions) => void;
  changeInfoAlertVisibility: (visible: boolean) => void;
}

export type InfoModalStore = InfoModalState & InfoModalAction;

const useInfoAlertStoreBase = create<InfoModalStore>()(
  devtools(
    (set, get) => ({
      isInfoAlertOpen: false,
      infoAlertOptions: null,
      openInfoAlert(options) {
        set({ isInfoAlertOpen: true, infoAlertOptions: options });
      },
      changeInfoAlertVisibility(visible) {
        set({ isInfoAlertOpen: visible });
      },
    }),
    {
      name: 'info-alert',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
);

export const useInfoAlertStore = createSelectors(useInfoAlertStoreBase);
